import { caseFilterhash } from '@debbie/common/dist/insights';
import * as api from '../api/cases';
import q from '../query';
import keys from '@debbie/common/dist/cache/keys';
export const caseInsightsTotalsKey = `case-insights-totals`;
export const useCaseInsightsTotals = () => q.query(caseInsightsTotalsKey, api.getInsightsTotals, []);
export const caseEntity = 'cases';
const caseKey = (id) => `cases-${id}`;
export const useCase = (id) => q.query(caseKey(id), () => api.getById(id), keys.read.item(caseEntity, id));
const caseListKey = (caseFilter, page, pageSize, filters, creditorId) => `cases-list-${caseFilterhash(caseFilter)}-${page}-${pageSize}-${(filters === null || filters === void 0 ? void 0 : filters.customerId) || ''}-${creditorId}`;
export const useCaseList = (caseFilter, page, pageSize, filters, creditorId) => q.query(caseListKey(caseFilter, page, pageSize, filters, creditorId), () => api.getAll(caseFilter, page * pageSize, pageSize, filters, creditorId), []);
//# sourceMappingURL=index.js.map